import { Tooltip } from '@mui/material';
import React, { useRef, useState } from 'react';

interface TruncatedHeaderTextProps {
  children: React.ReactNode;
  lines?: number;
}

export const TruncatedHeaderText = ({ children, lines = 3 }: TruncatedHeaderTextProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');

  return (
    <Tooltip
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={open}
      title={title}
    >
      <span
        onMouseEnter={() => {
          if (ref.current && ref.current.scrollHeight > ref.current.clientHeight) {
            setTitle(ref.current.textContent ?? '');
            setOpen(true);
          }
        }}
        onMouseLeave={() => setOpen(false)}
        ref={ref}
        style={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lines,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
